export var WINDOW_PADDING_HORIZONTAL = '12px';
